import { Navigate } from 'react-router-dom';
import { usePermissions, type ModuleName } from '@/hooks/useModulePermissions';
import { Loader2 } from 'lucide-react';

interface ModuleRouteProps {
  module: ModuleName;
  children: React.ReactNode;
}

export function ModuleRoute({ module, children }: ModuleRouteProps) {
  const { can, isLoading, isAdmin } = usePermissions();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // Admins always have access
  if (isAdmin) return <>{children}</>;

  // Check read permission for this module
  if (!can(module, 'read')) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
